var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"preloader"},[_c('div',{staticClass:"preloader__circle"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }